// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__24t0G","footer":"ModalUpdate_footer__HduR-"};